module.exports = __webpack_public_path__ + "static/media/airbnb_shap.711c54e3.csv";